import { css } from 'linaria';

export const utpCardMediaContainer = css`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  height: 100%;
`;

export const utpCardMedia = css`
  border-radius: 0 0 var(--rounding-l) 0;
`;
